export default {
    title: 'Dotácia',
    subtitle: 'Ak sa ti tento projekt páči, pomohol ti alebo chceš podporiť podobné projekty, môžeš prispieť/darovať sumu ktorú uznáš za vhodnú.',
    thankyou: 'Cením si akúkoľvek pomoc. Ďakujem'
}
